import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Companies',  href: '/#subsidiaries' },
  { label: 'Ventures',   href: '/#brands' },
  { label: 'VYASA',      href: '/#vyasa' },
  { label: 'Market',     href: '/#market' },
  { label: 'Insights',   href: '/insights' },
  { label: 'Leadership', href: '/#team' },
  { label: 'About',      href: '/#about' },
];

export default function Navbar() {
  const [scrolled,   setScrolled]   = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // After navigating to '/', scroll to stored target
  useEffect(() => {
    const target = sessionStorage.getItem('scrollTarget');
    if (target && location.pathname === '/') {
      sessionStorage.removeItem('scrollTarget');
      const attempt = (tries: number) => {
        const el = document.getElementById(target);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (tries > 0) {
          setTimeout(() => attempt(tries - 1), 150);
        }
      };
      setTimeout(() => attempt(5), 200);
    }
  }, [location.pathname]);

  const handleAnchorClick = (e: React.MouseEvent, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const id = href.replace('/#', '');
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      sessionStorage.setItem('scrollTarget', id);
      navigate('/');
    }
  };

  return (
    <nav className={`site-nav${scrolled ? ' scrolled' : ''}`}>
      <Link to="/" className="nav-logo" onClick={() => setMobileOpen(false)}>
        <img src="/apex%20logo%20small.png" alt="Apex DeFi Labs Inc." className="nav-logo-mark" />
        <div>
          <span className="nav-logo-text">Apex DeFi Labs Inc.</span>
          <span className="nav-logo-sub">Est. 2018 · New York</span>
        </div>
      </Link>

      <div className="nav-links">
        {navLinks.map((link) =>
          link.href.startsWith('/#') ? (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleAnchorClick(e, link.href)}
            >
              {link.label}
            </a>
          ) : (
            <Link key={link.href} to={link.href} onClick={() => setMobileOpen(false)}>
              {link.label}
            </Link>
          )
        )}
      </div>

      <button
        className="mobile-toggle"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle menu"
      >
        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {mobileOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {mobileOpen && (
        <div className="mobile-menu">
          {navLinks.map((link) =>
            link.href.startsWith('/#') ? (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleAnchorClick(e, link.href)}
              >
                {link.label}
              </a>
            ) : (
              <Link key={link.href} to={link.href} onClick={() => setMobileOpen(false)}>
                {link.label}
              </Link>
            )
          )}
        </div>
      )}
    </nav>
  );
}
